export class PhotoCapacitorUtils {
  static UPLOAD_IMAGE_HEIGHT_PX = 500;
  static UPLOAD_IMAGE_WIDTH_PX = 500;
  static MAX_IMAGE_SIZE_IN_MB = 1; //MB

  static base64DataToBase64WithFormat(
    base64Data: string,
    format: string
  ): string {
    return `data:image/${format};base64,${base64Data}`;
  }

  static isLessThanMaxSize(base64Data: string): boolean {
    // Convertir la cadena base64 a bytes
    const base64Length = base64Data.length;
    // Calcular el tamaño en bytes considerando la codificación base64
    const fileSizeInBytes =
      4 * Math.ceil(base64Length / 3) * 0.5624896334383812;

    // Convertir bytes a megabytes
    const fileSizeInMB = fileSizeInBytes / (1024 * 1024);

    return fileSizeInMB < this.MAX_IMAGE_SIZE_IN_MB;
  }
}
